/* פופאפ הרשמה · המרכז לנוחות ואורטופדיה. Vanilla JS, no dependencies (works with Eurus/Alpine untouched).
 * The coupon code is not in the page: it arrives only in the worker's /signup answer.
 * Events to the worker (/e): view, close. The 'submit' event is recorded by the worker itself. */
(function () {
  'use strict';
  if (window.__ortoPopupLoaded) return;
  window.__ortoPopupLoaded = true;

  var K = {
    subscribed: 'orto_popup_subscribed',  // sign-up time (ms)
    code: 'orto_popup_code',              // the code this visitor received
    snooze: 'orto_popup_snooze_until',
    barClosed: 'orto_popup_bar_closed',
    tabHidden: 'orto_popup_tab_hidden',   // session only
    vid: 'orto_popup_vid'
  };
  var OPEN_HASH = '#orto-popup-open';

  function store(kind) {
    return {
      get: function (k) { try { return window[kind].getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { window[kind].setItem(k, v); } catch (e) {} }
    };
  }
  var local = store('localStorage'), session = store('sessionStorage');

  // Attribution: the FIRST page of this browsing session (its utm_* and the external referrer) is kept
  // in sessionStorage, so a sign-up on the 3rd page still knows the visit came from e.g. WhatsApp.
  // Runs on every page load (the script is on every page while the section is on).
  var ATTR_KEY = 'orto_popup_attr';
  var UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  function captureAttribution() {
    var p, saved = null;
    try { saved = JSON.parse(session.get(ATTR_KEY) || 'null'); } catch (e) {}
    try { p = new URLSearchParams(location.search); } catch (e) { return; }
    var hasUtm = UTM.some(function (k) { return p.get(k); });
    if (saved && !hasUtm) return;            // first touch of the session wins…
    if (saved && saved.utm_source) return;   // …unless the first page had no UTM and this one has
    var a = { landing_url: location.origin + location.pathname + (hasUtm ? location.search : ''), referrer: '' };
    UTM.forEach(function (k) { a[k] = (p.get(k) || '').slice(0, 100); });
    try {
      var r = document.referrer ? new URL(document.referrer) : null;
      if (r && r.host !== location.host) a.referrer = r.origin + r.pathname;   // no query string
    } catch (e) {}
    if (saved && saved.referrer && !a.referrer) a.referrer = saved.referrer;
    session.set(ATTR_KEY, JSON.stringify(a));
  }
  function attribution() {
    try { return JSON.parse(session.get(ATTR_KEY) || 'null') || {}; } catch (e) { return {}; }
  }
  captureAttribution();
  function device() { return window.matchMedia && window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'; }

  function track(name, params) {
    params = params || {};
    params.device = device();
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish(name, params); } catch (e) {}
    try { window.dataLayer && window.dataLayer.push(Object.assign({ event: name }, params)); } catch (e) {}
  }

  var memVid = null;
  function visitorId() {
    var v = local.get(K.vid);
    if (!v) {
      v = memVid || ('v' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12));
      local.set(K.vid, v); memVid = v;
    }
    return v;
  }

  // Israeli mobile → +9725XXXXXXXX, else null (same rule as the worker)
  function normalizePhone(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.indexOf('972') === 0 && d.length >= 11) d = d.slice(3);
    d = d.replace(/^0+/, '');
    return /^5\d{8}$/.test(d) ? '+972' + d : null;
  }
  var NAME_RE = /^[A-Za-z֐-׿À-ɏЀ-ӿ؀-ۿ][A-Za-z֐-׿À-ɏЀ-ӿ؀-ۿ\s'"׳״.\-]{1,39}$/;

  function Popup(root) {
    this.root = root;
    try { this.cfg = JSON.parse(root.querySelector('[data-op-config]').textContent); } catch (e) { this.cfg = {}; }
    this.msg = this.cfg.msg || {};
    this.overlay = root.querySelector('[data-op-overlay]');
    this.box = root.querySelector('.op-box');
    this.form = root.querySelector('[data-op-form]');
    this.tab = root.querySelector('[data-op-tab]');
    this.isOpen = false;
    this.trigger = 'link';
    this.mountBar();
    this.bind();
    this.applyState();
    if (this.cfg.designMode) this.editorShow(); else this.maybeAutoOpen();
  }
  var P = Popup.prototype;

  P.api = function (path) { return String(this.cfg.workerUrl || '').replace(/\/+$/, '') + path; };

  P.beacon = function (event) {
    var cfg = this.cfg;
    if (!cfg.workerUrl || cfg.designMode) return;
    try {
      var body = JSON.stringify({ shop: cfg.shop, version: cfg.version, event: event, device: device(), trigger: this.trigger, page_type: cfg.pageType, visitor_id: visitorId() });
      var url = this.api('/e'), sent = false;
      if (navigator.sendBeacon) { try { sent = navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' })); } catch (e) {} }
      if (!sent && window.fetch) fetch(url, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', credentials: 'omit', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    } catch (e) {}
  };

  P.isSubscribed = function () {
    if (this.cfg.designMode) return false;
    if (this.cfg.serverSubscribed) return true;
    var at = parseInt(local.get(K.subscribed), 10) || 0;
    return at > 1 && Date.now() - at < (parseInt(this.cfg.hideAfterSignupDays, 10) || 365) * 864e5;
  };
  P.isSnoozed = function () { return (parseInt(local.get(K.snooze), 10) || 0) > Date.now(); };
  P.snooze = function () { local.set(K.snooze, String(Date.now() + (parseInt(this.cfg.reshowDays, 10) || 14) * 864e5)); };

  // the bar must sit above the header → moved to the top of <body>, keeping the colour variables
  P.mountBar = function () {
    var old = document.querySelectorAll('body > #OrtoPopupBar');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    this.bar = this.root.querySelector('#OrtoPopupBar');
    if (this.bar) {
      this.bar.setAttribute('style', this.root.getAttribute('style') || '');
      document.body.insertBefore(this.bar, document.body.firstChild);
    }
  };

  P.applyState = function () {
    var subscribed = this.isSubscribed();
    if (this.tab) this.tab.hidden = subscribed || (!this.cfg.designMode && session.get(K.tabHidden) === '1');
    var code = local.get(K.code);
    this.setBar(!!(subscribed && code && local.get(K.barClosed) !== '1'), code);
  };
  P.setBar = function (show, code) {
    if (!this.bar) return;
    if (code) this.fillCode(code);
    this.bar.hidden = !show;
  };
  P.fillCode = function (code) {
    var els = document.querySelectorAll('[data-op-code]');
    for (var i = 0; i < els.length; i++) els[i].textContent = code;
    this.code = code;
  };

  P.maybeAutoOpen = function () {
    var self = this;
    if (location.hash === OPEN_HASH) { this.open('link'); return; }
    var sec = parseInt(this.cfg.autoOpenSec, 10) || 0;
    if (!sec || !this.cfg.enabled || this.isSubscribed() || this.isSnoozed()) return;
    var tries = 0;
    var attempt = function () {
      // never on top of something else the visitor opened (cart drawer, menu, search): the theme locks
      // page scrolling while those are open → wait and try again, at most 6 times
      var busy = getComputedStyle(document.body).overflow === 'hidden' || getComputedStyle(document.documentElement).overflow === 'hidden';
      if (busy && ++tries <= 6) { self.autoTimer = setTimeout(attempt, 5000); return; }
      if (!busy) self.open('auto');
    };
    this.autoTimer = setTimeout(attempt, sec * 1000);
  };

  P.bind = function () {
    var self = this;
    this.onClick = function (e) {
      var t = e.target;
      var a = t.closest && t.closest('a[href$="' + OPEN_HASH + '"]');
      if (a) { e.preventDefault(); self.open('link'); return; }
      if (!self.root.contains(t) && !(self.bar && self.bar.contains(t))) return;
      if (t.closest('[data-op-open]')) { self.open('tab'); return; }
      if (t.closest('[data-op-tab-close]')) { session.set(K.tabHidden, '1'); self.applyState(); return; }
      if (t.closest('[data-op-bar-close]')) { local.set(K.barClosed, '1'); self.setBar(false); return; }
      if (t.closest('[data-op-copy]')) { self.copy(); return; }
      if (t.closest('[data-op-back]')) { self.showStep(1); return; }
      if (t.closest('[data-op-close]')) { self.close(); return; }
      if (t === self.overlay) self.close();
    };
    this.onKey = function (e) {
      if (!self.isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); self.close(); return; }
      if (e.key === 'Tab') self.trapFocus(e);
    };
    this.onHash = function () { if (location.hash === OPEN_HASH) self.open('link'); };
    document.addEventListener('click', this.onClick);
    document.addEventListener('keydown', this.onKey);
    window.addEventListener('hashchange', this.onHash);
    if (this.form) {
      // Enter or the button: step 1 → step 2, step 2 → send
      this.form.addEventListener('submit', function (e) { e.preventDefault(); if (self.step === 1) self.next(); else self.submit(); });
      this.form.addEventListener('input', function (e) {
        var k = e.target.getAttribute('data-op-input');
        if (k) self.clearError(k);
      });
      this.form.addEventListener('change', function (e) {
        if (e.target.getAttribute('data-op-input') === 'consent') self.clearError('consent');
      });
    }
  };

  P.focusables = function () {
    return Array.prototype.filter.call(
      this.box.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([tabindex="-1"]), [tabindex="0"]'),
      function (el) { return el.offsetParent !== null; });
  };
  P.trapFocus = function (e) {
    var f = this.focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === this.box)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  P.showView = function (name) {
    var v = this.root.querySelectorAll('[data-op-view]');
    for (var i = 0; i < v.length; i++) v[i].hidden = v[i].getAttribute('data-op-view') !== name;
  };

  /* ---------- two steps: 1) name + phone  2) email + consent. Nothing is sent before the end of step 2 ---------- */
  P.showStep = function (n, focus) {
    this.step = n;
    var steps = this.root.querySelectorAll('[data-op-step]'), dots = this.root.querySelectorAll('[data-op-dot]');
    for (var i = 0; i < steps.length; i++) steps[i].hidden = steps[i].getAttribute('data-op-step') !== String(n);
    for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-on', parseInt(dots[j].getAttribute('data-op-dot'), 10) <= n);
    var title = this.root.querySelector('[data-op-title]'), desc = this.root.querySelector('[data-op-desc]');
    if (title) title.textContent = title.getAttribute('data-step' + n) || title.textContent;
    if (desc) desc.textContent = desc.getAttribute('data-step' + n) || desc.textContent;
    this.clearError('form');
    if (focus !== false) {
      var f = this.input(n === 1 ? 'name' : 'email');
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    }
  };
  P.next = function () {
    var v = this.validate(1);
    if (!v.ok) return;
    this.showStep(2);
    if (!this.step2Sent && !this.cfg.designMode) { this.step2Sent = true; this.beacon('step2'); track('orto_popup_step2', { trigger: this.trigger }); }
  };

  P.open = function (trigger, view) {
    if (!this.overlay || this.isOpen) return;
    var self = this;
    clearTimeout(this.autoTimer);
    this.trigger = trigger === 'auto' || trigger === 'tab' ? trigger : 'link';
    this.lastFocus = document.activeElement;
    this.step2Sent = false;
    var done = this.isSubscribed() && this.code;
    this.showView(view || (done ? 'success' : 'form'));
    if (!done) this.showStep(1, false);
    this.overlay.hidden = false;
    this.isOpen = true;
    document.documentElement.classList.add('op-lock');
    requestAnimationFrame(function () {
      self.overlay.classList.add('is-open');
      self.box.scrollTop = 0;
      var first = self.form && !done ? self.form.querySelector('[data-op-input="name"]') : null;
      // auto-open: focus the dialog itself (no keyboard popping up on phones); a click: first field
      (trigger === 'auto' || !first ? self.box : first).focus({ preventScroll: true });
    });
    if (!this.cfg.designMode && !done) {
      if (trigger === 'auto') this.snooze();   // an auto-open is shown once per reshowDays even if ignored
      track('orto_popup_view', { trigger: this.trigger });
      this.beacon('view');
    }
  };

  P.close = function (silent) {
    if (!this.isOpen) return;
    var self = this;
    this.isOpen = false;
    this.overlay.classList.remove('is-open');
    document.documentElement.classList.remove('op-lock');
    setTimeout(function () { if (!self.isOpen) self.overlay.hidden = true; }, 220);
    if (!silent && !this.cfg.designMode && !this.isSubscribed()) {
      this.snooze();
      track('orto_popup_close', { trigger: this.trigger });
      this.beacon('close');
    }
    if (location.hash === OPEN_HASH) { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} }
    if (this.lastFocus && this.lastFocus.focus) { try { this.lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  };

  P.copy = function () {
    var code = this.code || local.get(K.code) || '', self = this;
    if (!code) return;
    var done = function () {
      var n = self.root.querySelector('[data-op-copied]');
      if (n) { n.textContent = self.msg.copied || ''; setTimeout(function () { n.textContent = ''; }, 2500); }
    };
    var fallback = function () {
      var ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:-100px;opacity:0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); done();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, fallback); else fallback();
    track('orto_popup_copy_code', {});
  };

  /* ---------- validation ---------- */
  P.input = function (n) { return this.form ? this.form.querySelector('[data-op-input="' + n + '"]') : null; };
  P.fields = function (key) { return [key]; };
  P.setError = function (key, text) {
    var p = this.root.querySelector('[data-op-err="' + key + '"]');
    if (p) p.textContent = text || '';
    this.fields(key).forEach(function (n) { var el = this.input(n); if (el) { el.classList.add('is-invalid'); el.setAttribute('aria-invalid', 'true'); } }, this);
  };
  P.clearError = function (key) {
    var p = this.root.querySelector('[data-op-err="' + key + '"]');
    if (p) p.textContent = '';
    this.fields(key).forEach(function (n) { var el = this.input(n); if (el) { el.classList.remove('is-invalid'); el.removeAttribute('aria-invalid'); } }, this);
  };

  // step 1 = name + phone, step 2 = email + consent, nothing = both (before sending)
  P.validate = function (step) {
    var m = this.msg, REQ = m.required || '', out = { ok: true, failStep: 0 }, first = null, self = this;
    var fail = function (key, el, text, st) { out.ok = false; self.setError(key, text); if (!first) { first = el; out.failStep = st; } };
    ['name', 'phone', 'email', 'consent', 'form'].forEach(this.clearError, this);

    if (step !== 2) {
      var name = this.input('name');
      out.name = name.value.trim().replace(/\s+/g, ' ');
      if (!out.name) fail('name', name, REQ, 1); else if (!NAME_RE.test(out.name)) fail('name', name, m.name || REQ, 1);

      var phone = this.input('phone');
      if (!phone.value.trim()) fail('phone', phone, REQ, 1);
      else if (!(out.phone = normalizePhone(phone.value))) fail('phone', phone, m.phone || REQ, 1);
    }

    if (step !== 1) {
      var email = this.input('email');
      out.email = email.value.trim().toLowerCase();
      if (!out.email) fail('email', email, REQ, 2);
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(out.email)) fail('email', email, m.email || REQ, 2);

      var c = this.input('consent');
      out.consent = !!(c && c.checked);
      if (this.cfg.consentRequired && !out.consent) fail('consent', c, m.consent || REQ, 2);
    }

    if (first) {
      if (out.failStep && out.failStep !== this.step) this.showStep(out.failStep, false);
      try { first.focus(); } catch (e) {}
    }
    return out;
  };

  /* ---------- submit → worker /signup ---------- */
  P.submit = function () {
    if (this.busy) return;
    var self = this, v = this.validate();
    if (!v.ok) return;
    var textEl = this.root.querySelector('[data-op-consent-text]');
    var hp = this.input('company');
    var attr = attribution();
    var body = JSON.stringify({
      utm_source: attr.utm_source || '', utm_medium: attr.utm_medium || '', utm_campaign: attr.utm_campaign || '',
      utm_content: attr.utm_content || '', utm_term: attr.utm_term || '', referrer: attr.referrer || '', landing_url: attr.landing_url || '',
      shop: this.cfg.shop, version: this.cfg.version, name: v.name, phone: v.phone, email: v.email, birthday: '',
      consent_checked: v.consent, consent_text: textEl ? textEl.textContent.replace(/\s+/g, ' ').trim() : '',
      page_url: location.href.split('#')[0].split('?')[0], device: device(), trigger: this.trigger, page_type: this.cfg.pageType,
      visitor_id: visitorId(), company: hp ? hp.value : ''
    });
    var btn = this.form.querySelector('[data-op-submit]');
    this.busy = true; btn.disabled = true; btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');

    var finish = function () { self.busy = false; btn.disabled = false; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); };
    if (this.cfg.designMode) { finish(); this.success('CODE'); return; }   // editor preview: never posts

    fetch(this.api('/signup'), { method: 'POST', body: body, credentials: 'omit', headers: { 'Content-Type': 'text/plain' } })
      .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { return { status: res.status, j: j }; }); })
      .then(function (r) {
        finish();
        if (r.status === 200 && r.j.ok && r.j.code) { self.success(r.j.code); return; }
        var m = self.msg, e = r.j && r.j.error;
        if (r.status === 400 && (e === 'name' || e === 'phone')) { self.showStep(1, false); self.setError(e, m[e]); var f = self.input(e); if (f) f.focus(); }
        else if (r.status === 400 && e === 'email') self.setError('email', m.email);
        else if (r.status === 400 && e === 'consent') self.setError('consent', m.consent);
        else if (r.status === 429) self.setError('form', m.rate);
        else self.setError('form', m.send);
      })
      .catch(function () { finish(); self.setError('form', self.msg.send); });
  };

  P.success = function (code) {
    if (!this.cfg.designMode) {
      local.set(K.subscribed, String(Date.now()));
      local.set(K.code, code);
      track('orto_popup_submit', { trigger: this.trigger });
      try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: 'orto-popup' }); } catch (e) {}
    }
    this.fillCode(code);
    this.showView('success');
    this.box.scrollTop = 0;
    var t = this.root.querySelector('[data-op-success-title]');
    if (t) t.focus({ preventScroll: true });
    this.applyState();
  };

  /* ---------- theme editor ---------- */
  P.editorShow = function () {
    var view = this.cfg.editorView;
    this.close(true);
    if (view === 'bar') { this.fillCode('CODE'); if (this.bar) this.bar.hidden = false; return; }
    if (this.bar) this.bar.hidden = true;
    if (view === 'none') return;
    if (view === 'success') this.fillCode('CODE');
    this.open('link', view === 'success' ? 'success' : 'form');
  };
  P.destroy = function () {
    clearTimeout(this.autoTimer);
    document.removeEventListener('click', this.onClick);
    document.removeEventListener('keydown', this.onKey);
    window.removeEventListener('hashchange', this.onHash);
    document.documentElement.classList.remove('op-lock');
    if (this.bar && this.bar.parentNode) this.bar.parentNode.removeChild(this.bar);
  };

  var current = null;
  function init() {
    if (current) { current.destroy(); current = null; }
    var root = document.getElementById('OrtoPopup');
    if (root) current = new Popup(root);
    window.OrtoPopup = current;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector && e.target.querySelector('#OrtoPopup')) init(); });
  document.addEventListener('shopify:section:unload', function (e) { if (current && e.target.contains(current.root)) { current.destroy(); current = null; } });
})();
